<template>
  <div style="display: flex; justify-content: space-between; align-items: center; padding: 15px 20px">
    <h4 style="margin-bottom: 0;">Danh sách lịch thi</h4>
    <el-button type="success" class="text-white" @click="createExamSchedule = true">
      <i class="el-icon-plus text-white"></i> <span>Thêm lịch thi</span>
    </el-button>
    <el-dialog title="Thêm mới lịch thi" :show-close="false" :visible.sync="createExamSchedule"
               v-if="createExamSchedule" width="50%">
      <hr style="padding: 0; margin-top: -20px"/>
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(handleCreateSchedule)">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px">
            <ValidationProvider vid="center" name="Trung tâm" rules="required" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Trung tâm <span style="color: red">*</span></label>
                <el-select v-model="form.center_id" filterable clearable placeholder="Chọn trung tâm">
                  <el-option
                      v-for="item in centers"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
            <ValidationProvider vid="typeExam" name="Loại ca thi" rules="required" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Loại ca thi <span style="color: red">*</span></label>
                <el-select v-model="form.type" filterable clearable placeholder="Chọn loại ca thi">
                  <el-option
                      v-for="item in examScheduleTypes"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px; margin-bottom: 20px">
            <ValidationProvider vid="dateExam" name="Ngày thi" rules="required" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Ngày thi <span style="color: red">*</span></label>
                <el-date-picker
                    style="width: 100%"
                    v-model="form.dateExam"
                    type="date"
                    align="right"
                    placeholder="Chọn ngày thi"
                    format="dd-MM-yyyy"
                    value-format="yyyy-MM-dd"
                    :default-value="new Date()"
                >
                </el-date-picker>
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
            <ValidationProvider vid="timeExam" name="Thời gian thi" rules="required" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Thời gian thi <span style="color: red">*</span></label>
                <el-time-picker
                    v-model="form.timeExam"
                    is-range class="w-100"
                    start-placeholder="Giờ bắt đầu"
                    end-placeholder="Giờ kết thúc"
                    placeholder="Chọn giờ thi"
                    :picker-options="{ step: '00:15' }"
                    format="HH:mm"
                    value-format="HH:mm"
                />
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 20px;">
            <div class="display-flex-column">
              <label>Hình thức thi</label>
              <el-select v-model="form.testForm" filterable clearable placeholder="Chọn trung tâm" disabled>
                <el-option
                    v-for="item in testForms"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                </el-option>
              </el-select>
            </div>
            <ValidationProvider vid="typeExam" name="Nhân sự coi thi" rules="required" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Nhân sự coi thi <span style="color: red">*</span></label>
                <el-select v-model="form.supervisor" filterable clearable placeholder="Chọn nhân sự coi thi">
                  <el-option
                      v-for="item in adminTests"
                      :key="item.id"
                      :label="item.user_name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
            <ValidationProvider vid="typeExam" name="Link nhóm zalo hỗ trợ" rules="required|max:100" v-slot="{ errors,classes }">
              <div class="display-flex-column">
                <label>Link nhóm zalo hỗ trợ <span style="color: red">*</span></label>
                <el-input v-model="form.link_group_zalo" placeholder="Nhập link nhóm zalo hỗ trợ"/>
              </div>
              <div class="fv-plugins-message-container">
                <div data-field="name" data-validator="notEmpty" class="fv-help-block">{{ errors[0] }}</div>
              </div>
            </ValidationProvider>
          </div>
          <div style="display: flex;justify-content: flex-end; gap: 5px; margin-top: 20px">
            <el-button class="button-cancel" @click="closeDialog">Đóng</el-button>
            <button
                v-loading="isLoading"
                type="submit"
                style="background: #5E00B6; color: white; padding-left: 15px; padding-right: 15px; border-radius: 4px"
                :disabled="isLoading">
              Xác nhận
            </button>
          </div>
        </form>
      </ValidationObserver>
    </el-dialog>
  </div>
</template>

<script>

import {examScheduleTypes, testForms} from "@/common/define";
import {CREATE_EXAM_SCHEDULE, GET_ALL_ADMIN_TEST} from "@/core/services/store/examSchedule/examSchedule";
import moment from "moment-timezone";

const EXAM_TYPE_THI_DAU_KHOA = 2;

export default {
  name: 'HeaderManageExamSchedule',
  data() {
    return {
      createExamSchedule: false,
      isLoading: false,
      examScheduleTypes,
      testForms,
      adminTests: [],
      form: {
        center_id: null,
        type: null,
        dateExam: '',
        timeExam: [],
        testForm: 1,
        supervisor: null,
        link_group_zalo: null,
        max_slots: null,
      }
    }
  },
  computed: {
    isEntranceExam() {
      return this.form.type === EXAM_TYPE_THI_DAU_KHOA;
    },
  },
  watch: {
    "form.type"(val) {
      if (val !== EXAM_TYPE_THI_DAU_KHOA) {
        this.form.max_slots = null;
      }
    },
  },
  props: {
    centers: {
      type: Array,
      default: [],
      required: true,
    }
  },

  created() {
    const now = new Date();
    const start = new Date(now.setHours(7, 0, 0, 0));
    const end = new Date(now.setHours(22, 0, 0, 0));
    this.form.timeExam = [start, end];
  },

  mounted() {
    this.getAdminTestList()
  },
  methods: {
    handleCreateSchedule() {
      this.isLoading = true
      const payload = {
        center_id: this.form.center_id,
        exam_date: this.form.dateExam,
        exam_type: this.form.type,
        exam_form: this.form.testForm,
        start_time: this.getTime(this.form.timeExam[0]),
        end_time: this.getTime(this.form.timeExam[1]),
        admin_profile_id: this.form.supervisor,
        link_group_zalo: this.form.link_group_zalo,
      };
      if (this.isEntranceExam) {
        payload.max_slots = this.form.max_slots;
      }
      this.$store.dispatch(CREATE_EXAM_SCHEDULE, payload).then(res => {
        if (!res.error) {
          this.$message.success('Thêm mới lịch thi thành công!')
          this.$emit('getListExamSchedule')
          this.createExamSchedule = false
          this.resetForm()
        }
      }).catch((e) => {
        console.log(e)
      }).finally(() => this.isLoading = false)
    },
    closeDialog() {
      this.resetForm()
      this.createExamSchedule = false
      this.isLoading = false
    },
    resetForm() {
      const now = new Date();
      this.form = {
        center_id: null,
        type: null,
        dateExam: '',
        timeExam: [new Date(now.setHours(7, 0, 0, 0)), new Date(now.setHours(22, 0, 0, 0))],
        testForm: 1,
        supervisor: null,
        link_group_zalo: null,
        max_slots: null,
      }
    },
    getTime(time) {
      const typeTime = typeof time
      switch (typeTime) {
        case "object":
          return moment(time).format("HH:mm:ss")
        case "string":
          return `${time}:00`
        default:
          return null
      }
    },
    getAdminTestList() {
      this.$store.dispatch(GET_ALL_ADMIN_TEST).then(res => {
        if (!res.error) {
          this.adminTests = res.data ?? []
        }
      })
    },
  },
}
</script>

<style scoped>
.exam-schedule-form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-bottom: 20px;
}

.exam-schedule-form__actions {
  grid-column: 1 / -1;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
  margin-top: 0;
}

.display-flex-column {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.button-cancel {
  background: #CACACA;
  color: black;
}

.button-cancel:hover {
  color: white;
  opacity: 90%;
}
</style>
